import mergeToNew from "@insite/client-framework/Common/mergeToNew";
import { orderTotalDisplayStyles } from "@insite/content-library/Components/OrderTotalDisplay";
import getColor from "@insite/mobius/utilities/getColor";
import { COLORS } from "@tSurya/theme/design";
import { css } from "styled-components";

orderTotalDisplayStyles.totalLabelGridItem = mergeToNew(orderTotalDisplayStyles.totalLabelGridItem, {
    css: css`
        border-top:1px solid ${getColor("primary")};
    `,
});
orderTotalDisplayStyles.totalValueGridItem = mergeToNew(orderTotalDisplayStyles.totalValueGridItem, {
    css: css`
        border-top:1px solid ${getColor("primary")};
    `,
});
orderTotalDisplayStyles.container = mergeToNew(orderTotalDisplayStyles.container, {
    gap: 10,
    css: css`
        margin-top:10px;
        background-color: ${getColor("common.accent")};
        padding: 20px;
    
    `,
});



